/**
 * Totales de carga aérea. ESPEJO de `logistic-back/src/shared/pricing/carga-aerea.ts`:
 * si se cambia uno, hay que cambiar el otro. El servidor manda — esto es
 * para mostrar lo mismo que se va a guardar mientras se llena el formulario.
 *
 *   peso línea kg       = peso por pieza × piezas        (lb → kg)
 *   volumen línea m³     = L × A × H (cm) × piezas / 1.000.000   (in → cm)
 *   peso volumétrico kg  = L × A × H (cm) × piezas / 6000  (factor IATA)
 *   peso cobrable kg     = máx(peso bruto, peso volumétrico)
 */
export const FACTOR_VOLUMETRICO_AEREO = 6000;

const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
const round3 = (n) => Math.round((Number(n) || 0) * 1000) / 1000;

export function calcularCargaAerea(detalles, pesoDeclaradoKg) {
  let numPiezas = 0;
  let pesoDetalle = 0;
  let cm3 = 0;

  for (const d of detalles || []) {
    const piezas = Number(d.numPiezas) || 0;
    const fDim = d.unidadDimension === 'in' ? 2.54 : 1;
    const fPeso = d.unidadPeso === 'lb' ? 0.45359237 : 1;
    const volPieza =
      (Number(d.largo) || 0) * fDim * (Number(d.ancho) || 0) * fDim * (Number(d.alto) || 0) * fDim;
    numPiezas += piezas;
    pesoDetalle += (Number(d.peso) || 0) * fPeso * piezas;
    cm3 += volPieza * piezas;
  }

  const declarado = Number(pesoDeclaradoKg);
  const pesoTotal = declarado > 0 ? declarado : pesoDetalle;
  const pesoVolumetrico = cm3 / FACTOR_VOLUMETRICO_AEREO;

  return {
    numPiezas,
    pesoDetalle: round2(pesoDetalle),
    pesoTotal: round2(pesoTotal),
    pesoVolumetrico: round2(pesoVolumetrico),
    pesoCobrable: round2(Math.max(pesoTotal, pesoVolumetrico)),
    volumenTotal: round3(cm3 / 1_000_000),
  };
}
